import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { TaskStateEnum } from "../../../AnnualWheel.types";

export interface TimelineTaskItem {
    id: string;
    title: string;
    status: TaskStateEnum;
    responsibleUserName: string | null;
    groupEntityName: string | null;
    deadline: string;
}

export interface StatusTimelineDrillDownDialogProps {
    activityId: string;
    activityName: string;
    monthKey: string;
    onClose: () => void;
}

export function useStatusTimelineDrillDownDialog(props: StatusTimelineDrillDownDialogProps) {
    const [year, month] = props.monthKey.split("-").map(Number);
    const url = `/activities/${props.activityId}/timeline-tasks?year=${year}&month=${month}`;
    const { isLoading, data } = useDotLegalQuery<Array<TimelineTaskItem>>(url);

    return { isLoading, data, year, month };
}
